import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import HomeCategoryCardComponent from "./HomeCategoryCardComponent";
import "../../../styles/components/home/categories/homeCategoryListComponent.scss";
import categoryActions from "../../../store/actions/products/categories/category.actions";

export const HomeCategoryListComponent = ({ categories }) => {
  if (!categories) return;

  return (
    <div className=" homeCategoriesContainer">
      <h1>קטלוג מוצרים</h1>
      <div className="homeCategoryListContainer">
        {categories.map((category) => {
          return <HomeCategoryCardComponent key={category.id} category={category} />;
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.categoryReducer.categories?.items, // Subscribe to categories state from the reducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeCategoryListComponent);